var _rect, _rect2, _line, _line2, _line3, _line4, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFq47(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.897656,
    y: 0.796094,
    width: 48.972,
    height: 48.972,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.134,
    y: 12.0305,
    width: 26.4993,
    height: 26.4993,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 38.7215,
    y1: 12.1824,
    x2: 49.9578,
    y2: 0.946085,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1.04763,
    y1: 49.8543,
    x2: 12.2839,
    y2: 38.618,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.4836,
    y1: 38.6199,
    x2: 49.7199,
    y2: 49.8562,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0.809788,
    y1: 0.944118,
    x2: 12.0461,
    y2: 12.1804,
    stroke: "#393B4A",
    strokeWidth: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.476 27.62V26.878L23.572 20.018H24.734V26.766H26.232V27.62H24.734V30H23.768V27.62H18.476ZM23.81 21.096L19.61 26.766H23.81V21.096ZM33.5019 20.732L29.5959 30H28.6019L32.5499 20.816H26.9499V19.976H33.5019V20.732Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFq47);
export default __webpack_public_path__ + "static/media/fq47.f0858e49aec3612391a7e81f11fa4f68.svg";
export { ForwardRef as ReactComponent };